import { useSelector } from 'react-redux';

import { RootState } from '../../../ducks/store';
import OverlaySpinner from '../OverlaySpinner/OverlaySpinner';

import './AppLevelOverlaySpinner.scss';

const AppLevelOverlaySpinner = () => {
  const { show } = useSelector((state: RootState) => {
    const { show } = state.overlay;
    return { show };
  });
  if (!show) {
    return null;
  }

  return <OverlaySpinner className="AppLevel" />;
};

export default AppLevelOverlaySpinner;
